// extracted by mini-css-extract-plugin
module.exports = {"fixList":"StoreMenu_fixList__18txD","ListHolder":"StoreMenu_ListHolder__3dZHa","SetLoading":"StoreMenu_SetLoading__2oHh5"};